import {  TblDecInvProyectoTesistum, VoidTblDecInvProyectoTesistum } from "./TblDecInvProyectoTesistum";
import { TblDecInvProyectoTesistaCronograma } from "./TblDecInvProyectoTesistaCronograma";
import { TblDecInvProyectoTesistaObjespec } from "./TblDecInvProyectoTesistaObjespec";

export interface SolicitudEstudianteItinerarioDTO {
    codigoProyecto: string,
    TituloProyecto: string,
    itinerario: TblDecInvProyectoTesistum,
    objespecificos: Array<TblDecInvProyectoTesistaObjespec>
    cronograma: Array<TblDecInvProyectoTesistaCronograma>
    
}

export function VoidSolicitudEstudianteItinerarioDTO(): SolicitudEstudianteItinerarioDTO {
    return {
    codigoProyecto:'',
    TituloProyecto: '',
    itinerario: VoidTblDecInvProyectoTesistum(),
    objespecificos: [],
    cronograma: [],
    }
}

export function SetSolicitudEstudianteItinerarioDTO(data: any): SolicitudEstudianteItinerarioDTO {
    return {
        codigoProyecto: data.codigoProyecto??'',
        TituloProyecto: data.TituloProyecto??'',
        itinerario: data.itinerario,
        objespecificos: data.objespecificos?? [],
        cronograma: data.cronograma?? [],
    }
}

export function SetEstudianteItinerarioDetalleDTO(data: any): SolicitudEstudianteItinerarioDTO {
    return {
        codigoProyecto: data.codigoProyecto??'',
        TituloProyecto: data.tituloProyecto??'',
        itinerario: data.itinerario,
        objespecificos: data.objetivos?? [],
        cronograma: data.cronograma?? [],
    }
}